/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Nav Default Currency
 */
export type SetDefaultCurrencyRequestNavDefaultCurrency = typeof SetDefaultCurrencyRequestNavDefaultCurrency[keyof typeof SetDefaultCurrencyRequestNavDefaultCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetDefaultCurrencyRequestNavDefaultCurrency = {
  HKD: 'HKD',
  USD: 'USD',
} as const;
